/* eslint-disable react/no-unknown-property */
import React from 'react';

export const getSocialEmbedScript = embedTypes => Array.from(embedTypes).map((type) => {
  if (type === 'Twitter') {
    return (
      <script
        async
        src="https://platform.twitter.com/widgets.js"
        charset="utf-8"
        key={type}
      />
    );
  }
  if (type === 'Facebook') {
    return (
      <script
        async="1"
        defer="1"
        crossOrigin="anonymous"
        src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&amp;version=v3.3"
        key={type}
      />
    );
  }
  if (type === 'Instagram') {
    return (
      <script
        async="1"
        defer="1"
        src="https://www.instagram.com/embed.js"
        key={type}
      />
    );
  }
  if (type === 'Ex.Co') {
    return (
      <script
        async="1"
        defer="1"
        src="//embed.playbuzz.com/sdk.js"
        key={type}
        id="playbuzz-sdk"
      />
    );
  }
  return false;
}).filter(Boolean);
